import React, { useEffect } from "react";
import { ScwLogo } from "../svg";
import common from "../helper/common";
import { useNavigate } from "react-router-dom";
import { RoleEnum } from "../constants/appConstant";
import { rebuildAppRouter } from "../router";
import { useAuth } from "../contexts/auth/authContext";

export default function StartPage() {
  const navigate = useNavigate();
  const { user, isLoading, setRoutesReady } = useAuth();
  
  useEffect(() => {    
    // Wait for auth context to finish loading
    if (isLoading) {
      return;
    }
    
    (async () => {
      // Use user from context instead of common.getUser() to avoid race conditions
      const currentUser = user || common.getUser();
      global.user = currentUser;
      
      if (currentUser && currentUser.id) {
        let _route;
        // Rebuild router with dynamic routes after user data is set
        await rebuildAppRouter();
        setRoutesReady(true);
          
        const defaultMenu = user.menus?.find((menu) => menu.isdefaultview === true);
        _route = defaultMenu?.endpoint; 
        navigate(_route, { replace: true });
      } else {
        // Try both /login and /Login to handle case sensitivity
        navigate("/login", { replace: true });
      }
    })();
  }, [user, isLoading, navigate]);

  // Fallback redirect after a timeout to ensure we don't get stuck
  useEffect(() => {
    const fallbackTimer = setTimeout(() => {
      const currentUser = user || common.getUser();
      if (!currentUser || !currentUser.id) {
        navigate("/login", { replace: true });
      }
    }, 2000); // 2 second fallback
    return () => clearTimeout(fallbackTimer);
  }, [navigate, user]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <ScwLogo className="text-primary h-68" />
    </div>
  );
}
